"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsDecimalStringValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isDecimal(input);
        }
        return false;
    }
}
exports.IsDecimalStringValidator = IsDecimalStringValidator;
//# sourceMappingURL=IsDecimalStringValidator.js.map